import { View, Text } from "react-native";
import React from "react";

const FanRallyTradeMark = () => {
  return (
    <View>
      <Text
        style={{ fontWeight: "700", textAlign: "center", color: "#cccccc" }}
      >
        Powered by FanRally
      </Text>
    </View>
  );
};

export default FanRallyTradeMark;
